import { useEffect } from "react";
import type { AuthState } from "../auth/authService";
import { identifyAnalyticsUser, resetAnalyticsClient } from "../analytics/client";
import { trackTaskpaneSessionStarted } from "../analytics/product";

export function useAnalyticsAuth(authState: AuthState): void {
  useEffect(() => {
    if (authState.isAuthenticated && authState.user) {
      identifyAnalyticsUser(authState.user);
      trackTaskpaneSessionStarted();
    } else {
      resetAnalyticsClient();
    }
  }, [authState.isAuthenticated, authState.user?.id, authState.user?.email]);
}
